export const heatingDegreeDay = (
  tn: number | null,
  tx: number | null,
  baseTemperature: number,
  costic = false,
) => {
  if (tx === null || tn === null) {
    return null;
  }

  let result: number;
  if (!costic) {
    result = Math.max(0, baseTemperature - (tx + tn) / 2);
  } else {
    if (baseTemperature > tx || baseTemperature < tn) {
      result = Math.max(0, baseTemperature - (tx + tn) / 2);
    } else {
      result =
        (baseTemperature - tn) *
        (0.08 + (0.42 * (baseTemperature - tn)) / (tx - tn));
    }
  }
  return result;
};

export const coolingDegreeDay = (
  tn: number | null,
  tx: number | null,
  baseTemperature: number,
  costic = false,
) => {
  if (tx === null || tn === null) {
    return null;
  }

  let result: number;
  if (!costic) {
    result = Math.max(0, (tx + tn) / 2 - baseTemperature);
  } else {
    if (baseTemperature > tx || baseTemperature < tn) {
      result = Math.max(0, (tx + tn) / 2 - baseTemperature);
    } else {
      result =
        (tx - baseTemperature) *
        (0.08 + (0.42 * (tx - baseTemperature)) / (tx - tn));
    }
  }
  return result;
};

type TnTx = [number, number]; // [TN, TX]

export const sumHeatingDegreeDay = (
  temperatureArray: TnTx[],
  baseTemperature: number,
  costic = false,
) => {
  return temperatureArray.length > 0
    ? temperatureArray.reduce((obj, item) => {
        obj += heatingDegreeDay(item[0], item[0], baseTemperature, costic);
        return obj;
      }, 0)
    : null;
};

export const sumCoolingDegreeDay = (
  temperatureArray: TnTx[],
  baseTemperature: number,
  costic = false,
) => {
  return temperatureArray.length > 0
    ? temperatureArray.reduce((obj, item) => {
        obj += coolingDegreeDay(item[0], item[0], baseTemperature, costic);
        return obj;
      }, 0)
    : null;
};
